import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { FavoriteIcon } from 'components/favorite-icon';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { StoreCardSeparator } from '../store-card-separator';

import { StoreCardActionsContainer } from './store-card-actions.styled';
import { StoreCardButton } from './store-card-button';

interface StoreCardActionsProps {
  onDiagnosticsClick?: () => void;
  onFavoritesClick?: () => void;
  isUpdatingFavorites?: boolean;
  isFavorite?: boolean;
}

export const StoreCardActions: React.FC<StoreCardActionsProps> = ({
  onDiagnosticsClick,
  onFavoritesClick,
  isUpdatingFavorites,
  isFavorite,
}) => {
  const { formatMessage } = useIntl();
  const enableFavorites = useFlag(LaunchDarklyFlag.ENABLE_FAVORITE_STORES);
  const { isAuthenticated } = useAuthContext();

  return (
    <StoreCardActionsContainer>
      {onDiagnosticsClick && (
        <StoreCardButton
          testID="store-favorite-button"
          accessibilityLabel="Open a diagnostic modal for this store"
          onPress={onDiagnosticsClick}
          icon={<Icon variant="settings" />}
        />
      )}
      {onDiagnosticsClick && onFavoritesClick && <StoreCardSeparator />}
      {isAuthenticated && enableFavorites && onFavoritesClick && (
        <StoreCardButton
          accessibilityLabel={
            isFavorite
              ? formatMessage({ id: 'removeFavorite' })
              : formatMessage({ id: 'setRestaurantAsFavorite' })
          }
          onPress={onFavoritesClick}
          icon={<FavoriteIcon loading={isUpdatingFavorites} isFavorite={isFavorite} />}
          isDisabled={isUpdatingFavorites}
        />
      )}
    </StoreCardActionsContainer>
  );
};
